import type { IconProps } from '../types/IconProps.ts';
export const Volume2: IconProps = {
    name: 'Volume2',
    children: [
        `<path d="M2 15V9a1 1 0 0 1 1-1h3.67a1 1 0 0 0 .6-.2l2.93-2.2a.5.5 0 0 1 .8.4v12.12a.5.5 0 0 1-.76.43l-4-2.4a1 1 0 0 0-.52-.15H3a1 1 0 0 1-1-1M16 9c.83 1 2 3.6 0 6M19 5c2.33 2.33 5.6 8.4 0 14" />`,
    ]
};